<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <div
      style="
        position: absolute;
        right: 100px;
        top: 50%;
        transform: translateY(-50%);
      "
    >
      <!-- <el-button
        type="danger"
        @click="$router.push('/groupOrder/orderingSystem')"
      >待拼单{{ realTimeOrderCount }}</el-button> -->
      <!-- <el-button
        type="danger"
        @click="$router.push('/groupOrder/orderMan')"
      >无法完成{{ orderPoolCount }}</el-button> -->
    </div>
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <div v-if="count > 0" class="newMsg" @click="$router.push('/setting/chat')">
      新消息&nbsp;&nbsp;&nbsp;{{ count }}
    </div>

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!-- <search id="header-search" class="right-menu-item" /> -->

        <error-log class="errLog-container right-menu-item hover-effect" />

        <!-- <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->

        <!-- <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
      </template>

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="hover"
      >
        <div class="avatar-wrapper" @click="shabi">
          <img src="@/assets/image/menager.png" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span
              style="display: block"
            >{{ userinfo.adminInfoVo.name }}({{
              userinfo.adminInfoVo.username
            }})</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span style="display: block">{{
              userinfo.adminInfoVo.loginIp
            }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <!-- <span>这是一段信息</span> -->
        <div>
          <!-- <el-button
            v-if="dynamicContentAutoChat"
            type="primary"
            size="mini"
            @click="jumoTo('/operation/autoGreeting')"
            >自动打招呼</el-button
          > -->
          <el-button
            v-if="dynamicContentWordLib"
            type="primary"
            class="edit-button"
            size="mini"
            @click="jumoTo('/operation/PUA')"
          >旧版本动态话术</el-button>
          <!-- <el-button
            v-if="dynamicContentAutoMember"
            type="primary"
            size="mini"
            @click="jumoTo('/operation/selectWoman')"
            >自选女性发动态</el-button
          >
          <el-button
            v-if="role"
            type="primary"
            size="mini"
            @click="jumoTo('/setting/role')"
            >角色分配</el-button
          >
            <el-button
            v-if="comment"
            type="primary"
            size="mini"
            @click="jumoTo('/setting/communityComment')"
            >导社区评论</el-button
          >
            <el-button
            v-if="chat"
            type="primary"
            size="mini"
            @click="jumoTo('/setting/chat')"
            >聊天</el-button
          > -->
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
import checkPermission from '@/utils/permission' // 全局权限控制
import checkAuthorities from '@/utils/authorities'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog
    // Screenfull,
  },
  data() {
    return {
      dialogVisible: false,
      time: 0,
      timer: null,
      isAudio: false,
      count: 0,
      realTimeOrderCount: 0,
      orderPoolCount: 0,
      intervalTime: null
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'userinfo', 'roles']),
    dynamicContentWordLib() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:dynamicContentWordLib')) {
        return true
      }
      return false
    },
    dynamicContentAutoChat() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:dynamicContentAutoChat')) {
        return true
      }
      return false
    },
    dynamicContentAutoMember() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:dynamicContentAutoMember')) {
        return true
      }
      return false
    },

    role() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:role')) {
        return true
      }
      return false
    },
    comment() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:comment')) {
        return true
      }
      return false
    },
    chat() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:chat')) {
        return true
      }
      return false
    }
  },
  mounted() {
    // this.intervalTime = setInterval(() => {
    //   this.$api.userDataMsg.warningNotice().then((res) => {
    //     this.realTimeOrderCount = res.realTimeOrderCount
    //     this.orderPoolCount = res.orderPoolCount
    //   })
    // }, 3000)
    // localStorage.setItem('count', 0)
  },
  beforeDestroy() {
    clearInterval(this.intervalTime)
  },
  methods: {
    checkAuthorities,
    checkPermission,
    // 获取列表
    getSystemWaitReplyList() {
      const params = {}
      this.$api.kefu
        .kefuWaitReplyList(params)
        .then((res) => {
          this.getUserInfos(res)
          this.loading = false
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 根据id获取用户信息
    getUserInfos(data) {
      if (data.length == 0) {
        this.userTable = data
        this.loading = false
        return
      }
      var ids = []
      data.forEach((item) => {
        ids.push(item.fromUserId)
      })
      // 数组去重
      ids = Array.from(new Set(ids))
      ids = ids.toString()
      // 根据被投诉用户id获取用户信息
      this.$api.global
        .findMemberBySns(ids)
        .then((res) => {
          data.forEach((item) => {
            var index = res.findIndex(
              (resItem) => resItem.sn == item.fromUserId
            )
            if (index != -1) {
              item.nickname = res[index].nickname
              item.username = res[index].username
              item.city = res[index].city
              item.sex = res[index].sex
              item.age = res[index].age
              item.vipLevel = res[index].vipLevel
              item.platform = res[index].platform
            }
          })
          this.userTable = data
          console.log(this.userTable)
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    shabi() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.time = 0
        clearTimeout(this.timer)
      }, 2000)
      if (this.time >= 4) {
        this.dialogVisible = true
        this.time = 0
        clearTimeout(this.timer)
      } else {
        this.time++
      }
    },
    jumoTo(url) {
      this.dialogVisible = false
      this.$router.push(`${url}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 20px;
          height: 20px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25%;
          font-size: 12px;
        }
      }
    }
  }
  .newMsg {
    cursor: pointer;
    line-height: 30px;
    float: left;
    margin-left: 20px;
    background: rgb(255, 227, 227);
    border: 1px solid rgb(255, 0, 0);
    height: 30px;
    margin-top: 10px;
    color: red;
    width: 100px;
    text-align: center;
    border-radius: 20px;
  }
}
</style>
